export const VOTING_TIME = 60000; // 60 seconds
export const TIME_OUT_DRAWING = 100;
